import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import T from 'i18n-react';

import { WithVehiclePermitsChecker } from '../../../../controllers/VehiclePermitsChecker/VehiclePermitsChecker.helpers';
import { formatText } from '../../../../utilities/formatters';
import proPropTypes from '../../../../utilities/proPropTypes';

import styles from './VehicleHighestBid.module.scss';

T.setTexts(require('../../../texts.json'));

const VehicleHighestBid = ({ className, permits }) => {
	const { label, showVAT, value } = permits.getHighestBid();
	const base = 'vehicleDetails.offers';

	return (
		<div className={cx(styles.highestBidContainer, className)}>
			<span>
				{T.translate(`${base}.highest`, {
					type: T.translate(`${base}.types.${label}`),
				})}
				{showVAT ? ' +VAT' : ''}
			</span>
			<span className={styles.highestBid}>{`£${formatText(value)}`}</span>
		</div>
	);
};

VehicleHighestBid.defaultProps = {
	className: null,
};

VehicleHighestBid.propTypes = {
	className: proPropTypes.className,
	icon: PropTypes.func,
	permits: proPropTypes.vehiclesPermitsChecker.isRequired,
};

export default WithVehiclePermitsChecker()(VehicleHighestBid);
